module.exports = __webpack_public_path__ + "static/media/truck_returns.aeeea8c7.svg";